import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOwner = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21.0039,
			r: 21,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 21.0039C23.7614 21.0039 26 18.7653 26 16.0039C26 13.2425 23.7614 11.0039 21 11.0039C18.2386 11.0039 16 13.2425 16 16.0039C16 18.7653 18.2386 21.0039 21 21.0039Z",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5901 31.0039C29.5901 27.1339 25.7402 24.0039 21.0002 24.0039C16.2602 24.0039 12.4102 27.1339 12.4102 31.0039",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgOwner;
